import { addMessages, init, getLocaleFromNavigator, locale, t } from 'svelte-i18n'
import { setupCommonsI18n } from '@repo/commons/i18n'

import appEn from './en.json'
// import appDe from './de.json'

export function setupI18n(): void {
	setupCommonsI18n()

	addMessages('en', appEn)
	// addMessages('de', appDe)
	addMessages('de', appEn) // TEMP: use English for German locale

	init({
		fallbackLocale: 'en',
		initialLocale: getLocaleFromNavigator()
	})
}

export { locale, t }
